<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :before-close="closeModal">


    <el-tabs v-model="activeTab" @tab-click="handleClick">

      <el-tab-pane :label="(mode=='Edit'||mode=='Create')?'':'New'" name="Edit">

        <fg-input label="Affiliate">
          <el-select class="removeReadonly" v-model="affiliateId" filterable placeholder="Select">
            <el-option
              v-for="affiliate in $store.getters.affiliates.filter(a => !a.archived)"
              :key="affiliate.id"
              :label="affiliate.firstName + ' ' + affiliate.lastName + ($store.getters.companySelected==0 ?
                                        ' ('+ $store.getters.getCompanyName(affiliate.affiliateCompanyId) + ')' : '')"
              :value="affiliate.id">
            </el-option>
          </el-select>
        </fg-input>

        <fg-input type="text"
                  label="Business Name"
                  placeholder="Name"
                  v-model="name"
                  @keyup.enter="confirm()"/>

        <fg-input type="text"
                  label="Main Contact Name"
                  placeholder="Name"
                  v-model="mainContactName"
                  @keyup.enter="confirm()"/>

        <fg-input type="text"
                  label="Main Contact Email"
                  placeholder="Email"
                  v-model="mainContactEmail"
                  @keyup.enter="confirm()"/>

        <fg-input label="Status">
            <Lead-Status-Input :lead="lead"
                  @keyup.enter="confirm()"/>
        </fg-input>

        <fg-input label="Notes">
          <el-input type="textarea"
                    :autosize="{minRows: 2}"
                    placeholder="Notes"
                    v-model="notes"
                    @keyup.enter="confirm()"/>
        </fg-input>
        
        <l-checkbox v-model="hot" @keyup.enter="confirm()">Hot Lead</l-checkbox>
      </el-tab-pane>


      <el-tab-pane v-if="showReceivedTab" label="Received" name="Received">
        <Leads-Table modal noRowClick :filter="$store.getters.Lead._status.RECEIVED"/>
      </el-tab-pane>

    </el-tabs>

    <span slot="footer" class="dialog-footer">
      <button class="btn" @click="closeModal()">Cancel</button>&nbsp;
      <button class="btn btn-success" :disabled="activeTab == 'Received' && $store.getters.selectedObjects.length < 1" @click="confirm()">{{buttonLabel}}</button>
    </span>
  </el-dialog>
</template>

<script>
import {Lead} from 'src/classes/datamodel.js'
export default {
  name: 'Lead-Modal',
  data () {
    return {
      selectedTab: '',
      closing: false // without this, the tab changes every time the modal is opened in Close/Lost mode
    }
  },
  computed: {
    mode () {
      return this.$store.getters.modal.mode
    },
    title () {
      return this.mode + ' Lead' // ADD 's' when multiple leads selected
    },
    visible () {
      return this.$store.getters.modal.current == 'Lead'
    },
    lead () {
      if (typeof this.$store.getters.modal.object == 'object' && this.$store.getters.modal.object.constructor.name == 'Lead') { // TODO: does this work when minimized??
        return this.$store.getters.modal.object
      }
      else {
        return new Lead()
      }
    },
    buttonLabel () {
      switch (this.mode) {
        case 'Create':
          return 'Create'
        case 'Edit':
          return 'Save'
        case 'Close':
          return this.activeTab == 'Edit' ? 'Save' : 'Close Leads'
        case 'Lost':
          return this.activeTab == 'Edit' ? 'Save' : 'Lost Leads'
        default:
          return 'Save'
      }
    },
    activeTab: { // TODO (?): WHEN CLOSING MODAL, MESSES UP THE ACTIVATE TAB FOR NEXT OPEN_MODAL
      get () {
        if (this.selectedTab) {
          return this.selectedTab
        }
        else {
          return this.showReceivedTab ? 'Received' : 'Edit'
        }
      },
      set (tab) {
        if (!this.closing) {
          this.selectedTab = tab
        }
      }
    },
    showReceivedTab () {
      // console.log('showReceivedTab(): ')
      // console.log(this.mode)
      // console.log(this.affiliateId)
      if (this.mode == 'Close' || this.mode == 'Lost') {
        let leads = this.$store.getters.leadsJson.filter(lead => lead.status == Lead._status.RECEIVED.value)
        // console.log(leads)
        if (this.affiliateId) {
          leads = leads.filter(lead => lead.affiliateId == this.affiliateId)
          // console.log(leads)
        }
        return leads.length > 0
      }
      else {
        return false
      }
    },
    affiliateId: {
      get ()    { return  this.lead.affiliateId },
      set (affiliateId) { this.lead.affiliateId = affiliateId }
    },
    name: {
      get () { return  this.lead.name },
      set (name)     { this.lead.name = name}
    },
    mainContactName: {
      get ()        { return  this.lead.mainContactName },
      set (mainContactName) { this.lead.mainContactName = mainContactName}
    },
    mainContactEmail: {
      get ()         { return  this.lead.mainContactEmail },
      set (mainContactEmail) { this.lead.mainContactEmail = mainContactEmail}
    },
    notes: {
      get () { return  this.lead.notes },
      set (notes)    { this.lead.notes = notes}
    },
    hot: {
      get () { return this.lead.hot },
      set (hot)     { this.lead.hot = hot}
    }
  },
  methods: {
    closeModal () {
      this.closing = true
      if (this.$store.getters.selectedObjectsJson) {
        this.$store.commit('STOP_SELECT_OBJECTS')
      }
      
      this.$store.dispatch('closeModal').then(function() {
        if (this) {
          this.closing = false
          this.selectedTab = ''
        }
      })
    },
    async confirm () {
      let action = ''
      let obj = null
      switch (this.mode) {
        case 'Create':
          this.lead.affiliateAccountId = this.$store.getters.affiliatesJson[this.affiliateId].affiliateAccountId
          action = 'createRestObject'
          obj = new Lead(this.lead)
          break
        case 'Edit':
          this.lead.affiliateAccountId = this.$store.getters.affiliatesJson[this.affiliateId].affiliateAccountId
          action = 'updateRestObject'
          obj = new Lead(this.lead)
          break
        case 'Close':
          if (this.selectedTab == 'Edit') {
            action = 'createRestObject'
            obj = new Lead(this.lead)
          }
          else {
            action = 'closeLeads'
          }
          break
        case 'Lost':
          if (this.selectedTab == 'Edit') {
            action = 'createRestObject'
            obj = new Lead(this.lead)
          }
          else {
            action = 'lostLeads'
          }
          break
        default:
          console.log('LeadModal>confirm(): unplanned mode')
          break
      }
      
      const res = await this.$store.dispatch(action, obj)
      // const errorMessage = !res || (res && res.errors  && res.errors.length > 0) ? res.errors.toString() : 'Error'
      if (res) {
        if (res.errors) {
          if (!res.errors[0] || typeof res.errors[0] != 'string' || !res.errors[0].toLowerCase().includes('session')) {
            this.$notify({ errorMessage: res.errors[0] })
          }
        }
        else {
          this.$notify({ successMessage: 'Saved!'})
          this.closeModal()
        }
      }
      else {
        this.$notify({ errorMessage: 'Something went wrong...'})
      }
    },
    handleClick (tab, event) {
      console.log('tab.name = ', tab.name)
      // console.log('event = ', event)
      this.selectedTab = tab.name
    }
  },
  watch: {
    visible: function (elem) {
      if (this.visible) {
        // console.log('this.$refs.tofocus.$el.children = ', this.$refs.tofocus.$el.children)
        if (this.activeTab == 'New' && !!this.affiliateId) {
          // doesn't work without the timeout..
          // setTimeout(() => this.$refs.tofocus.$el.children[0].focus(), 500)
          // this.$refs.tofocus.$el.children[0].focus()
        }
      }
    }
  }
}
</script>

<style>

</style>